import React from 'react';
import styles from './KnowledgeBaseList.module.scss';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import Icon from '../Icon/Icon';
import { CustomButton } from '../Button/Button';
import DashboardCards from '../../features/Dashboard/components/DashboardCards/DashboardCards';

import { HELPCENTER_LANGUAGES } from '../../../common/constants/common';

const KnowledgeBaseList = ({ knowledgeVideos, setIsShowKnowledgeBase, isMobileView }) => {
  const { t, i18n } = useTranslation();

  const openHelpcenter = () => {
    const language = HELPCENTER_LANGUAGES.find(item => item === i18n.language) ?? 'en';
    window.open(`https://support.vormats.com/${language}`, '_blank');
  };

  return (
    <div className={styles.mainWrapper}>
      <div className={cx(styles.header, { [styles.mobileHeader]: isMobileView })}>
        <CustomButton className={styles.backButton} onClick={() => setIsShowKnowledgeBase(false)} variant="link">
          <Icon src="back" className={styles.backIcon} />
          <span>{t('general.back')}</span>
        </CustomButton>
        <CustomButton
          label={t('home_page.go_to_helpcenter')}
          variant="basic"
          onClick={openHelpcenter}
          className={styles.goToHelpCenterButton}
        ></CustomButton>
      </div>

      <div className={styles.sectionWrapper}>
        <div className={styles.mainText}>{t('home_page.knowledge_base')}</div>
        <div className={styles.videoListContainer}>
          <DashboardCards
            hideActions={true}
            searchInput=""
            videos={knowledgeVideos}
            totalData={knowledgeVideos?.length}
            listMode={false}
            cardsHeaderId="cardsHeaderID"
          />
        </div>
      </div>
    </div>
  );
};

export default KnowledgeBaseList;
